// components/layout/Footer.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { trackPhoneClick, trackEmailClick } from '../../utils/tracking';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-gray-300">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-bold text-lime-400 mb-3">Lemay Roofing</h3>
            <p className="text-sm text-gray-400 leading-relaxed">
              Avon Park's trusted roofing experts. Over 30 years of quality craftsmanship protecting Florida homes.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => navigate('/services')} className="hover:text-lime-400 transition-colors">New Roof Installation</button></li>
              <li><button onClick={() => navigate('/services')} className="hover:text-lime-400 transition-colors">Roof Repair</button></li>
              <li><button onClick={() => navigate('/services')} className="hover:text-lime-400 transition-colors">Roof Inspections</button></li>
              <li><button onClick={() => navigate('/services')} className="hover:text-lime-400 transition-colors">Storm Damage</button></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><button onClick={() => navigate('/about')} className="hover:text-lime-400 transition-colors">About Us</button></li>
              <li><button onClick={() => navigate('/gallery')} className="hover:text-lime-400 transition-colors">Gallery</button></li>
              <li><button onClick={() => navigate('/testimonials')} className="hover:text-lime-400 transition-colors">Reviews</button></li>
              <li><button onClick={() => navigate('/blog')} className="hover:text-lime-400 transition-colors">Blog</button></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-2 text-sm">
              <li>Avon Park, FL</li>
              <li><a href="tel:+18634534555" onClick={trackPhoneClick} className="hover:text-lime-400 transition-colors">(863) 453-4555</a></li>
              <li><a href="mailto:info@lemayroofing.com" onClick={trackEmailClick} className="hover:text-lime-400 transition-colors">info@lemayroofing.com</a></li>
              <li className="pt-1 text-xs text-gray-500">Licensed & Insured</li>
            </ul>
            <button
              onClick={() => navigate('/request-quote')}
              className="mt-4 inline-block bg-lime-600 hover:bg-lime-700 text-white text-sm font-semibold px-5 py-2 rounded-lg transition-colors"
            >
              Free Quote
            </button>
          </div>
        </div>

        <div className="border-t border-slate-800 py-6 text-center text-sm text-gray-500">
          &copy; {currentYear} Lemay Roofing. All Rights Reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
